import React from "react";
import { useNavigate } from "react-router-dom";

function DecouverteDemoPage() {
  const navigate = useNavigate();

  return (
    <div className="discover-page">
      <button className="discover-back" onClick={() => navigate(-1)}>
        ← Retour
      </button>

      <div className="discover-bg-grid"></div>
      <div className="discover-glow glow-top"></div>
      <div className="discover-glow glow-bottom"></div>

      <div className="discover-radar">
        <div className="radar-circle circle-1"></div>
        <div className="radar-circle circle-2"></div>
        <div className="radar-circle circle-3"></div>
        <div className="radar-line"></div>

        <div className="discover-core">
          <span>Découverte</span>
          <small>Engagement + visibilité</small>
        </div>

        <div className="discover-card card-a">
          <strong>🔥 Vidéos courtes</strong>
          <small>Contenus rapides</small>
        </div>

        <div className="discover-card card-b">
          <strong>🎥 Lives</strong>
          <small>Créateurs actifs</small>
        </div>

        <div className="discover-card card-c">
          <strong>⭐ Tendances</strong>
          <small>Boost visibilité</small>
        </div>

        <div className="discover-card card-d">
          <strong>💬 Interactions</strong>
          <small>Engagement réel</small>
        </div>
      </div>

      <div className="discover-content">
        <p className="discover-label">EVO DISCOVERY</p>

        <h1>Découverte</h1>

        <p>
          Des contenus pensés pour favoriser l’engagement et la visibilité.
        </p>

       
      </div>

      <style>{`
        .discover-page {
          position: fixed;
          inset: 0;
          overflow: hidden;
          background:
            radial-gradient(circle at top, rgba(0,242,255,0.18), transparent 34%),
            linear-gradient(135deg, #02040a 0%, #03131d 45%, #02040a 100%);
          color: #ffffff;
          font-family: Arial, sans-serif;
        }

        .discover-back {
          position: absolute;
          top: 22px;
          left: 22px;
          z-index: 30;
          border: 1px solid #00f2ff;
          background: rgba(0,0,0,0.45);
          color: #00f2ff;
          padding: 10px 16px;
          border-radius: 14px;
          cursor: pointer;
          box-shadow: 0 0 18px rgba(0,242,255,0.35);
        }

        .discover-bg-grid {
          position: absolute;
          inset: 0;
          opacity: 0.16;
          background-image:
            linear-gradient(rgba(0,242,255,0.18) 1px, transparent 1px),
            linear-gradient(90deg, rgba(0,242,255,0.18) 1px, transparent 1px);
          background-size: 42px 42px;
          animation: gridMove 16s linear infinite;
        }

        .discover-glow {
          position: absolute;
          width: 360px;
          height: 360px;
          border-radius: 50%;
          filter: blur(80px);
          opacity: 0.45;
          background: #00f2ff;
          animation: glowFloat 5s ease-in-out infinite alternate;
        }

        .glow-top {
          top: -90px;
          left: 18%;
        }

        .glow-bottom {
          bottom: -120px;
          right: 12%;
          opacity: 0.28;
          animation-delay: 1.2s;
        }

        .discover-radar {
          position: absolute;
          left: 8%;
          top: 50%;
          transform: translateY(-50%);
          width: 520px;
          height: 520px;
          border-radius: 50%;
          animation: radarEnter 0.9s ease forwards;
        }

        .radar-circle {
          position: absolute;
          border-radius: 50%;
          border: 1px solid rgba(0,242,255,0.35);
          box-shadow: 0 0 28px rgba(0,242,255,0.18);
        }

        .circle-1 {
          inset: 55px;
          animation: pulseCircle 2.5s ease-in-out infinite;
        }

        .circle-2 {
          inset: 115px;
          animation: pulseCircle 2.5s ease-in-out infinite;
          animation-delay: 0.4s;
        }

        .circle-3 {
          inset: 175px;
          animation: pulseCircle 2.5s ease-in-out infinite;
          animation-delay: 0.8s;
        }

        .radar-line {
          position: absolute;
          left: 50%;
          top: 50%;
          width: 240px;
          height: 2px;
          background: linear-gradient(90deg, #00f2ff, transparent);
          transform-origin: left center;
          box-shadow: 0 0 22px rgba(0,242,255,0.8);
          animation: radarSpin 3.2s linear infinite;
        }

        .discover-core {
          position: absolute;
          left: 50%;
          top: 50%;
          width: 160px;
          height: 160px;
          transform: translate(-50%, -50%);
          border-radius: 50%;
          background:
            radial-gradient(circle, rgba(0,242,255,0.22), rgba(0,0,0,0.88));
          border: 1px solid rgba(0,242,255,0.55);
          box-shadow:
            0 0 35px rgba(0,242,255,0.45),
            inset 0 0 25px rgba(0,242,255,0.18);
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          text-align: center;
          z-index: 5;
          animation: corePulse 1.8s ease-in-out infinite;
        }

        .discover-core span {
          font-size: 20px;
          font-weight: 900;
          color: #ffffff;
        }

        .discover-core small {
          margin-top: 8px;
          color: #8df7ff;
          font-size: 12px;
        }

        .discover-card {
          position: absolute;
          width: 170px;
          padding: 16px;
          border-radius: 20px;
          background: rgba(2, 12, 18, 0.86);
          border: 1px solid rgba(0,242,255,0.35);
          box-shadow: 0 0 24px rgba(0,242,255,0.22);
          backdrop-filter: blur(12px);
          z-index: 8;
          opacity: 0;
          animation: cardScan 4s ease-in-out infinite;
        }

        .discover-card strong {
          display: block;
          font-size: 15px;
          margin-bottom: 6px;
        }

        .discover-card small {
          color: #9befff;
          font-size: 12px;
        }

        .card-a {
          top: 40px;
          left: 160px;
        }

        .card-b {
          top: 205px;
          right: 0;
          animation-delay: 0.5s;
        }

        .card-c {
          bottom: 50px;
          left: 155px;
          animation-delay: 1s;
        }

        .card-d {
          top: 205px;
          left: 0;
          animation-delay: 1.5s;
        }

        .discover-content {
          position: absolute;
          right: 8%;
          top: 50%;
          transform: translateY(-50%);
          max-width: 530px;
          animation: textEnter 1s ease forwards;
        }

        .discover-label {
          color: #00f2ff;
          font-size: 14px;
          font-weight: 900;
          letter-spacing: 4px;
          text-transform: uppercase;
          margin-bottom: 16px;
        }

        .discover-content h1 {
          font-size: 64px;
          line-height: 1;
          margin: 0 0 20px;
          color: #ffffff;
          text-shadow: 0 0 35px rgba(0,242,255,0.55);
        }

        .discover-content p {
          font-size: 20px;
          line-height: 1.6;
          color: #bdefff;
          margin-bottom: 32px;
        }

        .discover-btn {
          border: none;
          background: linear-gradient(90deg, #00f2ff, #009dff);
          color: #001018;
          padding: 15px 28px;
          border-radius: 18px;
          font-size: 17px;
          font-weight: 900;
          cursor: pointer;
          box-shadow: 0 0 30px rgba(0,242,255,0.55);
          animation: btnPulse 1.7s ease-in-out infinite;
        }

        @keyframes gridMove {
          from { background-position: 0 0; }
          to { background-position: 84px 84px; }
        }

        @keyframes radarSpin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }

        @keyframes pulseCircle {
          0%, 100% {
            opacity: 0.35;
            transform: scale(1);
          }
          50% {
            opacity: 0.9;
            transform: scale(1.04);
          }
        }

        @keyframes corePulse {
          0%, 100% {
            transform: translate(-50%, -50%) scale(1);
          }
          50% {
            transform: translate(-50%, -50%) scale(1.06);
          }
        }

        @keyframes cardScan {
          0% {
            opacity: 0;
            transform: translateY(18px) scale(0.9);
          }
          20%, 70% {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
          100% {
            opacity: 0;
            transform: translateY(-12px) scale(0.96);
          }
        }

        @keyframes radarEnter {
          from {
            opacity: 0;
            transform: translateY(-50%) translateX(-80px) scale(0.9);
          }
          to {
            opacity: 1;
            transform: translateY(-50%) translateX(0) scale(1);
          }
        }

        @keyframes textEnter {
          from {
            opacity: 0;
            transform: translateY(-42%);
          }
          to {
            opacity: 1;
            transform: translateY(-50%);
          }
        }

        @keyframes btnPulse {
          0%, 100% {
            transform: scale(1);
            box-shadow: 0 0 24px rgba(0,242,255,0.45);
          }
          50% {
            transform: scale(1.06);
            box-shadow: 0 0 42px rgba(0,242,255,0.75);
          }
        }

        @keyframes glowFloat {
          from { transform: translateY(0) scale(1); }
          to { transform: translateY(-35px) scale(1.12); }
        }

        @media (max-width: 900px) {
          .discover-radar {
            left: 50%;
            top: 40%;
            width: 360px;
            height: 360px;
            transform: translate(-50%, -50%);
          }

          .discover-core {
            width: 125px;
            height: 125px;
          }

          .discover-card {
            width: 135px;
            padding: 12px;
          }

          .card-a {
            top: 12px;
            left: 112px;
          }

          .card-b {
            top: 145px;
            right: -5px;
          }

          .card-c {
            bottom: 16px;
            left: 112px;
          }

          .card-d {
            top: 145px;
            left: -5px;
          }

          .radar-line {
            width: 165px;
          }

          .discover-content {
            left: 24px;
            right: 24px;
            top: auto;
            bottom: 35px;
            transform: none;
            text-align: center;
          }

          .discover-content h1 {
            font-size: 42px;
          }

          .discover-content p {
            font-size: 16px;
          }
        }
      `}</style>
    </div>
  );
}

export default DecouverteDemoPage;
